<script setup lang="ts">
import { RouterView, useRouter } from 'vue-router'
import { computed, onMounted, watchEffect } from 'vue'
import { useTheme } from 'vuetify'

// API
// Services
import { initModalService } from '@/core/services/modal'

// Composables
import { useAppTheme } from '@/core/composables/useAppTheme'

// Components
// Initialize services
initModalService()

// Initialize theme
useAppTheme()

const theme = useTheme()

// Load platform information using TanStack Query
// Apply platform branding to theme
watchEffect(() => {

  // Update theme colors
  theme.themes.value.light.colors.primary = "#0066CC"
  theme.themes.value.dark.colors.primary = "#0066CC"


  theme.themes.value.light.colors.secondary = "#004080"
  theme.themes.value.dark.colors.secondary = "#004080"

})

</script>

<template>
  <v-app>
    <!-- Loading state -->

    <!-- Error state -->

    <!-- Main application -->
    <RouterView />

    <!-- TanStack Query DevTools (only in development) -->
    <!-- <VueQueryDevtools v-if="isDevelopment" /> -->
  </v-app>
</template>

<style scoped></style>
